var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box",style:({height: _vm.height + 'px'})},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_vm._t("title"),_vm._t("btn")],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }